import * as React from 'react';
import CountrySelect from "../../common/CountrySelect/CountrySelect";
import TrackableElement from "../../common/TrackableElement";
import Icon from "../../common/Icon/Icon";

import { ReactComponent as MessengerIcon } from '../../../images/icons/messenger.svg';
import { ReactComponent as LinkedInIcon } from '../../../images/icons/linkedin.svg';
import { ReactComponent as FacebookIcon } from '../../../images/icons/facebook.svg';

import * as styles from './BottomNavigation.module.scss';

class BottomNavigation extends React.Component {
  render() {
    return (
      <section className={styles.root}>
        <div className={styles.container}>
          <div className={styles.selectContainer}>
            <p className={styles.title}>Country</p>
            <CountrySelect />
          </div>
          <div className={styles.linksContainer}>
            <div className={styles.linksColumn}>
              <a href='https://flatfy.ee/media-kit' target="_blank" rel="noopener noreferrer">Media Kit</a>
              <a href='https://flatfy.com/terms-of-use' target="_blank" rel="noopener noreferrer">Term of Use</a>
            </div>
            <div className={styles.linksColumn}>
              <a href='https://flatfy.com/cookies' target="_blank" rel="noopener noreferrer">Cookie Policy</a>
              <a href='https://flatfy.com/privacy-policy' target="_blank" rel="noopener noreferrer">Privacy Policy</a>
            </div>
          </div>
          <div className={styles.accountsContainer}>
            <div className={styles.links}>
              <TrackableElement
                element="a"
                eventCategory="social_media"
                eventAction="in"
                href='https://www.linkedin.com/company/flatfycom/about'
                target="_blank"
                rel="noopener noreferrer"
              >
                 <Icon component={LinkedInIcon} />
              </TrackableElement>
            </div>
            <div className={styles.links}>
              <TrackableElement
                element="a"
                eventCategory="social_media"
                eventAction="fb"
                href='https://www.facebook.com/flatfy'
                target="_blank"
                rel="noopener noreferrer"
              >
                <Icon component={FacebookIcon}/>
              </TrackableElement>
            </div>
            <div className={styles.links}>
              <TrackableElement
                  element="a"
                  eventCategory="social_media"
                  eventAction="ms"
                  href='https://m.me/flatfy'
                  target="_blank"
                  rel="noopener noreferrer"
              >
                 <Icon component={MessengerIcon} />
              </TrackableElement>
            </div>
          </div>
        </div>
        <div className={styles.author}>
          © Flatfy Inc
        </div>
      </section>
    )
  }
}

export default BottomNavigation;
